import confirm from 'antd/lib/modal/confirm';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useToast } from '@quinyx/ui';

import AdminForm from '../../../forms/admin';
import { handleError } from '../../../api/utils';
import { useDeleteAdmin } from '../../../hooks/admin';
import { withAdminLayout } from '../../../layouts/admin';
import { useTranslate } from '../../../hooks/translate';

const DeleteAdmin = () => {
  const { validateEmail, deleteAdmin, isLoading } = useDeleteAdmin();
  const createToast = useToast();
  const { t } = useTranslate();

  const onSubmit = async ({ email }: { email: string }) => {
    try {
      await validateEmail(email);
      confirm({
        title: t('admin.deleteSystemAdmin'),
        content: <p>{t('admin.deleteSystemAdminConfirm', { email })}</p>,
        icon: <ExclamationCircleOutlined />,
        okText: t('common.yes'),
        okType: 'danger',
        cancelText: t('common.no'),
        onOk: async () => {
          await deleteAdmin(email);
          createToast({
            message: t('toast.systemAdminRightsRevoked'),
            type: 'positive',
          });
        },
      });
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <AdminForm
      formTitle={t('admin.deleteSystemAdmin')}
      formDescription={t('admin.systemAdminAccessNote')}
      onSubmit={onSubmit}
      buttonText={t('admin.revokeAccess')}
      isLoading={isLoading}
    />
  );
};

export default withAdminLayout(DeleteAdmin);
